import type {RouteLocationRaw} from 'vue-router';
import {safelyNavigateTo} from '@malt/utils';

/**
 * Handles built-in MF → host `window` events inside the host Nuxt app before optional Vue emits.
 *
 * @returns `true` when the event was fully handled and must not be re-emitted to the parent component.
 */
export function handleBuiltInMicroFrontendHostEvents(name: string, args: unknown[]): boolean {
    if (name === 'mf-navigate-to') {
        const to = args[0] as RouteLocationRaw | undefined | null;
        const options = args[1] as Parameters<typeof safelyNavigateTo>[1];
        void safelyNavigateTo(to, options);
        return true;
    }
    return false;
}
